import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class OurServices3 extends React.Component {
    state = {
        services: [],
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.SERVICES.GET_ALL)
            .then(res => {
                this.setState({ services: res.data.data, loading: false });
            })
            .catch(err => {
                console.error("Error fetching services", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { services, loading } = this.state;
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">All</span> Services</h2>
                                </div>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="row">
                                {loading ? (
                                    <div className="text-center p-a50">Loading services...</div>
                                ) : (
                                    services.map((item, index) => (
                                        <div key={index} className="col-md-4 col-sm-6">
                                            <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                                                <div className="mt-icon-box-sm inline-icon text-primary m-b20 radius bg-primary scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                                    {/* We can use a default flaticon or use item.icon if we added it, for now use a default */}
                                                    <span className="icon-cell text-secondry"><i className="flaticon-city" /></span>
                                                </div>
                                                <div className="icon-content">
                                                    <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.name}</h4>
                                                    <p>{(item.description || '').substring(0, 100)}...</p>
                                                    <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices3;
